// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__4oIus","tableHead":"TableRow_tableHead__nzYxf"};